import React, { useState } from "react"
import { HStack, Link, Text } from "@chakra-ui/react"
import TOSModal from "./TOSModal"

export default function SidebarFooter() {
  const [open, setOpen] = useState(false)

  const onOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <TOSModal isOpen={open} onClose={handleClose} />
      <HStack justifyContent="center" alignItems="center" width="100%" m={1}>
        <Link
          href="https://blindinsight.com"
          isExternal
          fontSize={{ base: "xs", md: "sm", lg: "md" }}
        >
          &copy; 2025, Blind Insight, Inc.
        </Link>
        <Text>|</Text>
        <Link
          href="https://docs.blindinsight.io"
          isExternal
          fontSize={{ base: "xs", md: "sm", lg: "md" }}
        >
          View docs
        </Link>
        <Text>|</Text>
        <Link
          href="https://www.blindinsight.com/privacy-policy"
          isExternal
          fontSize={{ base: "xs", md: "sm", lg: "md" }}
        >
          Privacy Policy
        </Link>
        <Text>|</Text>
        <Link
          as="button"
          onClick={onOpen}
          fontSize={{ base: "xs", md: "sm", lg: "md" }}
        >
          Terms of Service
        </Link>
      </HStack>
    </>
  )
}
